"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectField = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var functions_1 = require("./functions");
var SelectField = function (props) {
    var options = props.options, placeholder = props.placeholder, searchable = props.searchable, _a = props.labelKey, labelKey = _a === void 0 ? 'label' : _a, _b = props.valueKey, valueKey = _b === void 0 ? 'value' : _b, disabled = props.disabled, _c = props.clearable, clearable = _c === void 0 ? true : _c, name = props.name, value = props.value, onChange = props.onChange, _d = props.isMulti, isMulti = _d === void 0 ? false : _d;
    var _e = __read(react_1.useState(null), 2), selectedvalue = _e[0], setSelectedValue = _e[1];
    react_1.useEffect(function () {
        var matchingOption = options.find(function (option) { return option[valueKey] === value; });
        if (matchingOption) {
            setSelectedValue({ label: matchingOption[labelKey], value: matchingOption[valueKey] });
        }
    }, [value, options, valueKey, labelKey]);
    var id = functions_1.generateId(name);
    var mappedOptions = options.map(function (option) { return ({
        label: option[labelKey],
        Id: option[valueKey]
    }); });
    return react_1.default.createElement(react_select_1.default, { name: name, instanceId: id, inputId: id, value: selectedvalue, options: mappedOptions, onChange: function (item) { setSelectedValue(item); onChange(item.Id); }, isSearchable: searchable, isClearable: clearable, isDisabled: disabled, placeholder: placeholder, "aria-label": labelKey, defaultValue: valueKey, escapeClearsValue: clearable, backspaceRemovesValue: clearable, isMulti: isMulti });
};
exports.SelectField = SelectField;
exports.SelectField.displayName = 'SelectField';
//# sourceMappingURL=SelectField.js.map